import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide"]
  static values = {
    interval: { type: Number, default: 20000 }
  }

  connect() {
    this.index = 0
    this.total = this.slideTargets.length
    if (this.total === 0) return
    this.preloadNextImage()
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    this.stop()
    const delay = this.currentDuration()
    this.timer = setTimeout(() => this.next(), delay)
  }

  stop() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }

  next() {
    const current = this.slideTargets[this.index]
    const nextIndex = (this.index + 1) % this.total
    const next = this.slideTargets[nextIndex]

    current.classList.remove('is-active')
    current.classList.add('is-leaving')
    // simple fade: remove leaving after animation end
    setTimeout(() => current.classList.remove('is-leaving'), 500)

    next.classList.add('is-active')
    this.index = nextIndex

    this.preloadNextImage()
    this.start()
  }

  currentDuration() {
    const current = this.slideTargets[this.index]
    const override = parseInt(current.getAttribute('data-tv-duration'), 10)
    if (!Number.isNaN(override) && override > 0) return override

    // If video slide, try to use metadata duration if available
    const video = current.querySelector('video')
    if (video && video.duration && isFinite(video.duration)) {
      return Math.max((video.duration * 1000), 3000)
    }
    return this.intervalValue
  }

  preloadNextImage() {
    const nextIndex = (this.index + 1) % this.total
    const next = this.slideTargets[nextIndex]
    if (!next) return
    const bg = next.querySelector('.cover')
    if (bg) {
      const style = bg.getAttribute('style') || ''
      const match = style.match(/url\\(['"]?([^'"]+)['"]?\\)/)
      if (match && match[1]) {
        const img = new Image()
        img.src = match[1]
      }
    }
    // Preload images inside the next slide
    next.querySelectorAll('img').forEach(imgEl => {
      if (imgEl && imgEl.dataset && imgEl.dataset.src) {
        imgEl.src = imgEl.dataset.src
      } else if (imgEl && imgEl.src) {
        // already has src; browser caches
      }
    })
  }
}


